import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useManageSubscription } from "@/hooks/useManageSubscription";

interface PastDueBannerProps {
  show: boolean;
}

export function PastDueBanner({ show }: PastDueBannerProps) {
  const { manage, loading } = useManageSubscription();
  if (!show) return null;
  return (
    <div className="w-full bg-destructive/10 border-b border-destructive/30 px-4 py-2 text-sm text-destructive flex items-center justify-center gap-3">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>Your last payment failed. Update your payment method to keep your subscription active.</span>
      <Button size="sm" variant="outline" onClick={manage} disabled={loading}>
        {loading ? "Opening…" : "Update payment"}
      </Button>
    </div>
  );
}
